import { Button, Form, Modal, Select, message } from "antd";
import { useState } from "react";

import { useMutation, useQuery } from "@tanstack/react-query";
import {
  addToSub,
  getAlbumFromSubscription,
  getMusicFromSubscription,
  updateSubscription,
} from "../../../utils/api";

const AddTo = ({ refech, update, row }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const type = Form.useWatch("type", form);
  console.log(row);

  const { data: curMusics } = useQuery({
    queryKey: ["musics", row?._id, visible],
    queryFn: async () => await getMusicFromSubscription(row?._id),
    enabled: visible && !!row?._id,
  });
  const { data: CurAlbums } = useQuery({
    queryKey: ["albums", row?._id],
    queryFn: async () => await getAlbumFromSubscription(row?._id),
    enabled: visible && !!row?._id,
  });
  const { mutate, isLoading } = useMutation(
    async (values) =>
      update
        ? await updateSubscription(update._id, values)
        : await addToSub(values),
    {
      onSuccess: () => {
        messageApi.success(`Added to Subscription Successfully`);
        //reset form
        !update && form.resetFields();

        setVisible(false);
      },
      onError: (err) => {
        messageApi.error(err?.response?.data?.message);
      },
    }
  );

  return (
    <div>
      {contextHolder}
      <Button
        style={{
          width: "100%",
        }}
        type="primary"
        onClick={() => setVisible(true)}
      >
        {update ? "Update" : "Add Music/Album"}
      </Button>
      <Modal
        title={update ? "Update " : "Add   "}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 8 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          initialValues={
            update && {
              title: update.name,
              description: update.description,
              price: update.price,
              validity: update.validity,
              isReward: update.isReward,
              musicRewardCoin: update.musicRewardCoin,
              videoRewardCoin: update.videoRewardCoin,
            }
          }
          defaultValue={{
            type: "Music",
          }}
          onFinish={(values) => {
            console.log(values);

            mutate({
              ...values,
              subscriptionId: row._id,
            });
          }}
        >
          {/* <Select mode="multiple" placeholder="Select ">
        {musics?.map((item) => (
          <Select.Option key={item._id} value={item._id}>
            {item.name}
          </Select.Option>
        ))}
      </Select> */}{" "}
          <Form.Item label="Type" name="type" required>
            <Select>
              <Select.Option value="Music">Music</Select.Option>
              <Select.Option value="Album">Album</Select.Option>
            </Select>
          </Form.Item>
          {type === "Music" ? (
            <Form.Item label="Music" name="musicIds" required>
              <Select placeholder="Select Music" mode="multiple">
                {curMusics?.map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item label="Album" name="albumIds" required>
              <Select placeholder="Select Album" mode="multiple">
                {CurAlbums?.map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default AddTo;
